import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../Styles/tab.css";
function Tab() {

    const [activeTab, setActiveTab] = useState('tab1');
    const openCity = (event, tabId) => {
        document.querySelectorAll('.tabcontent').forEach(tab => {
            tab.style.display = 'none';
        });
        document.querySelectorAll('.tablinks').forEach(link => {
            link.classList.remove('active');
        });

        document.getElementById(tabId).style.display = 'block';
        event.currentTarget.classList.add('active');
        setActiveTab(tabId);
    };

    return (
        <div className="shapeBG2">
            <div className="container">
                <div className="profTitle">
                    <h3>Explore Profiles Based on Your Criteria</h3>
                </div>

                <div className="mainTabs">
                    <div className="tab">
                        <button className={`tablinks ${activeTab === 'tab1' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab1')}>Mother Tongue</button>
                        <button className={`tablinks ${activeTab === 'tab2' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab2')}>Community</button>
                        <button className={`tablinks ${activeTab === 'tab3' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab3')}>Religion</button>
                        <button className={`tablinks ${activeTab === 'tab4' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab4')}>Profession</button>
                        <button className={`tablinks ${activeTab === 'tab5' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab5')}>Country</button>
                        <button className={`tablinks ${activeTab === 'tab6' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab6')}>Age</button>
                        <button className={`tablinks ${activeTab === 'tab7' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab7')}>Education</button>
                        <button className={`tablinks ${activeTab === 'tab8' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab8')}>Interests</button>
                        <button className={`tablinks ${activeTab === 'tab9' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab9')}>Marital Status</button>
                        <button className={`tablinks ${activeTab === 'tab10' ? 'active' : ''}`} onClick={(e) => openCity(e, 'tab10')}>Income Level</button>
                        {/* <button className={`tablinks ${activeTab === 'tab4'? 'active' : ''}`} onClick={(e) => openCity(e, 'tab4')}>City</button>
                        <button className={`tablinks ${activeTab === 'tab5'? 'active' : ''}`} onClick={(e) => openCity(e, 'tab5')}>Occupation</button>
                        <button className={`tablinks ${activeTab === 'tab6'? 'active' : ''}`} onClick={(e) => openCity(e, 'tab6')}>State</button>
                        <button className={`tablinks ${activeTab === 'tab7'? 'active' : ''}`} onClick={(e) => openCity(e, 'tab7')}>NRI</button>
                        <button className={`tablinks ${activeTab === 'tab8'? 'active' : ''}`} onClick={(e) => openCity(e, 'tab8')}>College</button> */}
                    </div>

                    <div id="tab1" className="tabcontent" style={{ display: activeTab === 'tab1' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">Hindi</a>
                            <a href="#"> | Marathi</a>
                            <a href="#"> | Punjabi</a>
                            <a href="#"> | Tamil</a>
                            <a href="#"> | Telugu</a>
                            <a href="#"> | Bengali</a>
                            <a href="#"> | Gujarati</a>
                            <a href="#"> | Urdu</a>
                            <a href="#"> | Kannada</a>
                            <a href="#"> | Odia</a>
                            <a href="#"> | Malayalam</a>
                            <a href="#"> | Marwari</a>
                            <a href="#"> | Sindhi</a>
                            <a href="#"> | English</a>
                            <a href="#"> | Assamese</a>
                            <a href="#"> | Bhojpuri</a>
                            <a href="#"> | Konkani</a>
                            <a href="#"> | Rajasthani</a>
                            <a href="#"> | Garhwali</a>
                            <a href="#"> | Maithili</a>
                            <a href="#"> | Haryanvi</a>
                            <a href="#"> | Tulu</a>
                            <a href="#"> | Dogri</a>
                            <a href="#"> | Manipuri</a>
                            <a href="#"> | Santhali</a>
                            <a href="#"> | Kashmiri</a>
                            <a href="#"> | Bundeli</a>
                            <a href="#"> | Magahi</a>
                            <a href="#"> | Awadhi</a>
                            <a href="#"> | Angika</a>
                            <a href="#"> | Khasi</a>
                            <a href="#"> | Mizo</a>
                            <a href="#"> | Naga</a>
                            <a href="#"> | Sikkimese</a>
                            <a href="#"> | Meitei</a>
                        </p>

                    </div>

                    <div id="tab2" className="tabcontent" style={{ display: activeTab === 'tab2' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">Brahmin</a>
                            <a href="#"> | Kshatriya</a>
                            <a href="#"> | Scheduled Castes</a>
                            <a href="#"> | Scheduled Tribes</a>
                            <a href="#"> | Other Backward Classes (OBC)</a>
                            <a href="#"> | Jain</a>
                            <a href="#"> | Sikh</a>
                            <a href="#"> | Muslim</a>
                            <a href="#"> | Christian</a>
                            <a href="#"> | Buddhist</a>
                            <a href="#"> | Parsi</a>
                            <a href="#"> | Jewish</a>
                            <a href="#"> | Bania</a>
                            <a href="#"> | Kayastha</a>
                            <a href="#"> | Rajput</a>
                            <a href="#"> | Maratha</a>
                            <a href="#"> | Nair</a>
                            <a href="#"> | Koli</a>
                            <a href="#"> | Lingayat</a>
                            <a href="#"> | Reddy</a>
                            <a href="#"> | Kamma</a>
                            <a href="#"> | Vellalar</a>
                            <a href="#"> | Naidu</a>
                            <a href="#"> | Mudaliar</a>
                            <a href="#"> | Vysya</a>
                        </p>

                    </div>

                    <div id="tab3" className="tabcontent" style={{ display: activeTab === 'tab3' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">| Hindu</a>
                            <a href="#">| Muslim</a>
                            <a href="#">| Sikh</a>
                            <a href="#">| Christian</a>
                            <a href="#">| Jain</a>
                            <a href="#">| Buddhist</a>
                            <a href="#">| Parsi</a>
                            <a href="#">| Jewish</a>
                        </p>
                    </div>

                    <div id="tab4" className="tabcontent" style={{ display: activeTab === 'tab4' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">Engineer</a>
                            <a href="#"> | Doctor</a>
                            <a href="#"> | Teacher</a>
                            <a href="#"> | IT Professional</a>
                            <a href="#"> | Business Owner</a>
                            <a href="#"> | Government Employee</a>
                            <a href="#"> | Lawyer</a>
                            <a href="#"> | Architect</a>
                            <a href="#"> | Nurse</a>
                            <a href="#"> | Scientist</a>
                            <a href="#"> | Accountant</a>
                            <a href="#"> | Pharmacist</a>
                            <a href="#"> | Consultant</a>
                            <a href="#"> | Electrician</a>
                            <a href="#"> | Carpenter</a>
                            <a href="#"> | Mechanic</a>
                            <a href="#"> | Chef</a>
                            <a href="#"> | Marketing Executive</a>
                            <a href="#"> | Sales Manager</a>
                            <a href="#"> | Researcher</a>
                            <a href="#"> | Artist</a>
                        </p>

                    </div>

                    <div id="tab5" className="tabcontent" style={{ display: activeTab === 'tab5' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">India</a>
                            <a href="#"> | United States</a>
                            <a href="#"> | Canada</a>
                            <a href="#"> | Australia</a>
                            <a href="#"> | United Kingdom</a>
                            <a href="#"> | Germany</a>
                            <a href="#"> | France</a>
                            <a href="#"> | Japan</a>
                            <a href="#"> | China</a>
                            <a href="#"> | Brazil</a>
                            <a href="#"> | South Africa</a>
                            <a href="#"> | Russia</a>
                            <a href="#"> | Italy</a>
                            <a href="#"> | Spain</a>
                            <a href="#"> | Mexico</a>
                            <a href="#"> | Indonesia</a>
                            <a href="#"> | Turkey</a>
                            <a href="#"> | Argentina</a>
                            <a href="#"> | Saudi Arabia</a>
                            <a href="#"> | Netherlands</a>
                            <a href="#"> | Sweden</a>
                        </p>

                    </div>

                    <div id="tab6" className="tabcontent" style={{ display: activeTab === 'tab6' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">| 18-24</a>
                            <a href="#">| 25-30</a>
                            <a href="#">| 31-35</a>
                            <a href="#">| 36-40</a>
                            <a href="#">| 41-45</a>
                            <a href="#">| 46-50</a>
                            <a href="#">| 51 and above</a>
                        </p>
                    </div>

                    <div id="tab7" className="tabcontent" style={{ display: activeTab === 'tab7' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">No Formal Education</a>
                            <a href="#"> | Primary School</a>
                            <a href="#"> | Secondary School</a>
                            <a href="#"> | Higher Secondary (12th Grade)</a>
                            <a href="#"> | Diploma/Certificate Course</a>
                            <a href="#"> | Bachelor’s Degree (BA, BSc, BCom, etc.)</a>
                            <a href="#"> | Master’s Degree (MA, MSc, MCom, MBA, etc.)</a>
                            <a href="#"> | Professional Degree (MBBS, BTech, LLB, etc.)</a>
                            <a href="#"> | Doctorate (PhD)</a>
                            <a href="#"> | Vocational Training</a>
                        </p>

                    </div>
                    <div id="tab8" className="tabcontent" style={{ display: activeTab === 'tab8' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">Traveling</a>
                            <a href="#"> | Reading</a>
                            <a href="#"> | Cooking</a>
                            <a href="#"> | Music</a>
                            <a href="#"> | Dancing</a>
                            <a href="#"> | Sports</a>
                            <a href="#"> | Photography</a>
                            <a href="#"> | Gardening</a>
                            <a href="#"> | Painting/Drawing</a>
                            <a href="#"> | Hiking</a>
                            <a href="#"> | Yoga</a>
                            <a href="#"> | Fitness</a>
                            <a href="#"> | Movies</a>
                            <a href="#"> | Writing</a>
                            <a href="#"> | Volunteering</a>
                            <a href="#"> | Technology</a>
                            <a href="#"> | Gaming</a>
                            <a href="#"> | Crafting</a>
                            <a href="#"> | Fashion</a>
                            <a href="#"> | Collecting</a>
                        </p>


                    </div>
                    <div id="tab9" className="tabcontent" style={{ display: activeTab === 'tab9' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">Single</a>
                            <a href="#"> | Engaged</a>
                            <a href="#"> | Married</a>
                            <a href="#"> | Divorced</a>
                            <a href="#"> | Widowed</a>
                            <a href="#"> | Separated</a>
                            <a href="#"> | Annulled</a>
                        </p>


                    </div>
                    <div id="tab10" className="tabcontent" style={{ display: activeTab === 'tab10' ? 'block' : 'none' }}>
                        <p className="categorySec">
                            <a href="#">Below ₹1,00,000</a>
                            <a href="#"> | ₹1,00,000 - ₹3,00,000</a>
                            <a href="#"> | ₹3,00,001 - ₹5,00,000</a>
                            <a href="#"> | ₹5,00,001 - ₹10,00,000</a>
                            <a href="#"> | ₹10,00,001 - ₹20,00,000</a>
                            <a href="#"> | Above ₹20,00,000</a>
                            <a href="#"> | Prefer not to disclose</a>
                        </p>


                    </div>
                </div>

                <div className="indAbout text-center">
                    <h3>About IND Matrimony</h3>
                    <p>As one of India’s most successful matrimonial websites, <strong>IND Matrimony</strong> has helped numerous members find their perfect match. Our approach focuses on simplicity, security, and trust. All profiles are rigorously screened before going live, and our free privacy features keep your information secure. We also verify contact details to ensure authenticity</p>
                    <p>Create a free account and browse profiles according to your preferences like age, profession, community, and more. With custom notifications and regular updates, your journey toward finding your life partner has never been easier. </p>
                </div>
            </div>
        </div>
    )
}

export default Tab